import { useState } from "react";
import { ResourceDetailDrawer } from "@/components/dashboard/ResourceDetailDrawer";
import { ResourceHeatmap } from "@/components/dashboard/ResourceHeatmap";
import { PageContainer } from "@/components/shared/PageContainer";
import { PageHeader } from "@/components/shared/PageHeader";

export function SchedulePage() {
  const [openResourceId, setOpenResourceId] = useState<string | null>(null);

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Manage"
        title="Schedule"
        description="Resource load by week — spot capacity risk and rebalance Pods."
      />

      <ResourceHeatmap onOpenResource={setOpenResourceId} />

      {openResourceId && (
        <ResourceDetailDrawer id={openResourceId} onClose={() => setOpenResourceId(null)} />
      )}
    </PageContainer>
  );
}
